import { IArticleWidgetProps } from "../components/DataDisplay/ArticleWidget/ArticleWidget.interface";
import { IMediaBuilderProps } from "../components/Utility/MediaBuilder/MediaBuilder";

export const articleWidgetImageData = {
  type: "image",
  data: {
    src: "assets/images/widget/article-banner-large.png",
    alt: "",
  },
} as IMediaBuilderProps;

export const articleWidgetData: IArticleWidgetProps = {
  id: "12345",
  tags: ["fitness", "outdoor"],
  title:
    "feel the different tour feel the different tour feel the different tour",
  description:
    "Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team ",
  mediaData: articleWidgetImageData,
  commentsCount: 48,
  readInfo: 8,
};

export const articleWidgetCarouselData: IArticleWidgetProps[] = [
  {
    id: "0",
    tags: ["fitness", "outdoor"],
    title: "feel the different tour",
    description:
      "Discover gear from the National Team Discover gear from the National Team Discover gear from the National Team",
    mediaData: articleWidgetImageData,
    commentsCount: 48,
    readInfo: 8,
  },
  {
    id: "1",
    tags: ["fitness", "outdoor"],
    title: "feel the different tour",
    description: "Discover gear from the National Team",
    mediaData: articleWidgetImageData,
    commentsCount: 48,
    readInfo: 8,
  },
  {
    id: "2",
    tags: ["fitness", "outdoor"],
    title: "feel the different tour",
    description: "Discover gear from the National Team",
    mediaData: articleWidgetImageData,
    commentsCount: 48,
    readInfo: 8,
  },
  {
    id: "3",
    tags: ["fitness", "outdoor"],
    title: "feel the different tour",
    description: "Discover gear from the National Team",
    mediaData: articleWidgetImageData,
    commentsCount: 48,
    readInfo: 8,
  },
  {
    id: "4",
    tags: ["fitness", "outdoor"],
    title: "feel the different tour",
    description: "Discover gear from the National Team",
    mediaData: articleWidgetImageData,
    commentsCount: 48,
    readInfo: 8,
  },
];
